/**
 * Приватные срезы стора, которые поле не рисует: тосты, реакции игроков,
 * итоги раунда и чат матча. Их изменения перерисовку поля не запускают (см.
 * checkIfFieldStateUnchanged)
 */
export const FIELD_IGNORED_PRIVATE_SLICES = ['toast', 'policyToast', 'reactions', 'roundStandings', 'matchChat'];

/**
 * Не изменилось ли с прошлой перерисовки ничего, что рисует поле: общее
 * состояние то же, а из приватных срезов поменялись разве что те, что поле
 * не читает (FIELD_IGNORED_PRIVATE_SLICES). Redux при неизменном срезе
 * возвращает тот же объект — сравнения по ссылке достаточно.
 *
 * Перерисовка поля полная и дорогая (тысячи объектов сцены), а такие
 * экшены идут постоянно: тосты, чат, реакции соперников
 * @param {Object|null} prevState - состояние прошлой перерисовки
 * @param {Object} nextState
 * @returns {boolean}
 */
export const checkIfFieldStateUnchanged = (prevState, nextState) => {
  if (!prevState || !nextState) {
    return false;
  }
  if (prevState === nextState) {
    return true;
  }
  if (prevState.shared !== nextState.shared) {
    return false;
  }
  const prevPrivate = prevState.private || {};
  const nextPrivate = nextState.private || {};
  if (prevPrivate === nextPrivate) {
    return true;
  }
  const sliceKeys = new Set([...Object.keys(prevPrivate), ...Object.keys(nextPrivate)]);
  return [...sliceKeys].every((sliceKey) => (
    FIELD_IGNORED_PRIVATE_SLICES.includes(sliceKey) || prevPrivate[sliceKey] === nextPrivate[sliceKey]
  ));
};
